import React from 'react';
import { useLanguage } from '../../context/language/LanguageContext';
import { acceptanceData } from '../../utils/acceptanceData';
import './AcceptanceSeason.css';

const AcceptanceSeason = () => {
    const { language } = useLanguage();

    return (
        <div className="acceptance-page">
            {/* Hero Section */}
            <div className="hero-section">
                <div className="hero-overlay">
                    <h1>{acceptanceData[language].title}</h1>
                    <div className="hero-badge">
                        <p>{acceptanceData[language].subtitle}</p>
                    </div>
                </div>
            </div>

            {/* Content Section */}
            <div className="content-container">
                <div className="feature-section">
                    {acceptanceData[language].sections.map((section, index) => (
                        <div key={index} className="feature-card">
                            <div className="card-header">
                                <div className="icon-box">
                                    <i className={section.icon}></i>
                                </div>
                                <h3>{section.title}</h3>
                            </div>
                            <ul className="feature-list">
                                {section.bullets.map((bullet, bulletIndex) => (
                                    <li key={bulletIndex}>
                                        <span className="bullet-point">•</span>
                                        <p>{bullet}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AcceptanceSeason;